<script setup>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { ElButton  } from 'element-plus';
import { useProductStore } from '../stores/fpe';

const store = useProductStore();

const { isUpdating, strings,  } = storeToRefs(store);

const pro = ref(fpe.editor_config.pro || false);


</script>

<template>
    <el-button class="fpe-cancel" @click="store.togglePanel">{{strings.cancel_button}}</el-button>
    <el-button :loading="isUpdating" class="fpe-update" type="primary" @click="store.updateProduct">{{ strings.update_button }}</el-button>
</template>